import * as Sentry from '@sentry/browser';

import {parseJwt} from './parseJwt';

import type {ChannelSession} from '../types/network';

export const state = {
  channelSessionAlreadyInitialized: false
};

export const updateSentryUserCodeFromChannelSession = async () => {
  if (!state.channelSessionAlreadyInitialized) {
    return;
  }

  const result = await globalThis.heliport.v3.api.channelSessionApi.getChannelSessionJwt();
  if (!result.data) {
    throw new Error('heliport.v3.api.channelSessionApi.getChannelSessionJwt() returns null');
  }

  Sentry.setTag('user_code', (parseJwt(result.data) as ChannelSession).user_code);
};
